import { FC } from "react";
import { useField, useFormikContext } from "formik";
import { Field } from 'formik';
import { 
    FormControlLabel,
    Checkbox
} from '@mui/material';

export const CustomCheckbox: FC = (props: any) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    return (
        <>
            <Field
                as={FormControlLabel}
                label={props.label}
                name={props.name}
                checked={field.value} 
                onChange={(val) => 
                    setFieldValue(field.name, !field.value)
                }
                control={<Checkbox />}
             />
        </>
    );
};